import { State } from "./State";
import App from "../../../core/src/App";
import GameEvents from "../const/GameEvents";
import ViewManager from "../../../core/src/utils/ViewManager";
import UIController from "../../src/ui/UIController";
import { UIStates } from "../../src/ui/UIStates";
import ReelGroup from "../../src/views/ReelGroup";
import { DefaultLayers } from "../../src/utils/Layers";
import AutoplayModel from "../model/AutoplayModel";
import SpinModel from "../model/SpinModel";

export default class LoopLinesState extends State {

    public enter(): void {
        super.enter();
        UIController.setState(UIStates.WIN);
        this.loopWin();
    }

    public canExit() {
        return true;
    }

    // public exit() {
    //     // App.dispatcher.off(GameEvents.SHOW_WIN_LINES_COMPLETE, this.loopWin, this);
    //     // App.dispatcher.off(GameEvents.SHOW_WIN_LINES_COMPLETE, this.exit, this);
    //     super.exit();
    //     // if (!spinModel.hasFreespins() && !autoplayModel.isAutoSpinActive()) {
    //     //     this.stateMachine.skip();
    //     // }

    // }

    protected loopWin() {
        const scene = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        reelGroup.displaySpinResults(SpinModel.winsData,App.config.repeatLines,App.config.showIndividualWins);
        this.exit();
    }
}
